import { EXPRESSION_VARIABLE_NAME } from '@shared/constants/expression-variables-names.constant';
import { getNiaFromDesign } from '@shared/helpers/design/activity-mix.helpers';
import { getHeatedArea } from '@shared/helpers/energy/energy.helpers';
import type { ExpressionVariables } from '@shared/helpers/expression-variables.helpers';
import { guards } from '@shared/helpers/typeguards.helpers';
import { BuildingDesign } from '@shared/models/design/building-design.model';
import type { ProjectMetadata } from '@shared/models/project.model';

export type BoverketHeatedAreaInput = {
  design: BuildingDesign;
  /** Version-level variables; only {@link EXPRESSION_VARIABLE_NAME.HEATED_AREA} is read. */
  versionExpressionVariables?: Pick<
    ExpressionVariables,
    typeof EXPRESSION_VARIABLE_NAME.HEATED_AREA
  >;
  projectMeta?: ProjectMetadata;
};

/**
 * Heated area (Atemp) for Boverket energiklass — matches {@link useHeatedArea}:
 * version atemp override, then design NIA, then legacy metadata GFA-based atemp.
 */
export const resolveHeatedAreaForBoverketExport = ({
  design,
  versionExpressionVariables,
  projectMeta,
}: BoverketHeatedAreaInput): number => {
  const atempOverride =
    versionExpressionVariables?.[EXPRESSION_VARIABLE_NAME.HEATED_AREA];
  if (guards.is.number(atempOverride)) return atempOverride;

  const nia = getNiaFromDesign(design);
  if (nia > 0) return nia;

  return projectMeta ? getHeatedArea(projectMeta) : 0;
};
